import { FormGroup } from "@angular/forms";
import { Transform, plainToInstance } from "class-transformer";
import { FormAnswerObject, FormAnswer } from "./form-answer.model";
import { FormTemplateQuestion } from "./form-template-question.model";
import { QuestionRangeValue } from "./question-range.model";

export class QuestionNPS extends FormTemplateQuestion {
  @Transform(({ obj }) => ({
    name: obj.questionRangeGroup.name,
    description: obj.questionRangeGroup.description,
    ranges: obj.questionRangeGroup.ranges.map((q) => plainToInstance(QuestionRangeValue, q)),
  }))
  questionRangeGroup: {
    name: string;
    description: string;
    ranges: QuestionRangeValue[];
  };

  public collectAnswer(formGroup: FormGroup, isEdit: boolean): FormAnswer[] | null {
    if (["", null].includes(formGroup.value[this.getName()])) {
      return null;
    }

    const formAnswer = new FormAnswer();
    formAnswer.formTemplateQuestionId = this.id;
    formAnswer[this.getAnswerDataField(isEdit)[0]] = Number(formGroup.value[this.getName()]);
    // update default value to null if it is -999
    if (formAnswer[this.getAnswerDataField(isEdit)[0]] === -999) {
      formAnswer[this.getAnswerDataField(isEdit)[0]] = null;
    }

    return [formAnswer];
  }

  public readDataFromAnswers(
    answers: FormAnswerObject,
    isEdit = false,
    field: "label" | "value" | "description" = "label"
  ): string | number {
    if (answers[this.id]) {
      const answer = answers[this.id];
      const rangeValue = this.questionRangeGroup.ranges.find(
        (range) => range.value === answer[this.getAnswerDataField(isEdit)[0]]
      );
      return rangeValue ? rangeValue[field] : "";
    }
    return "";
  }
}
